/* eslint-disable */

export const logActions = [
  {
    key: 'building_passport.update',
    value: 'updated Building Passport'
  },
  {
    key: 'building_passport.files.add',
    value: 'added a new file'
  },
  {
    key: 'building_passport.files.delete',
    value: 'deleted a file'
  },
  {
    key: 'building_passport.files.restore',
    value: 'restored a file'
  },
  {
    key: 'building_passport.files.new_version',
    value: 'uploaded a new version of a file'
  },
  {
    key: 'building_unit_passport.files.new_version',
    value: 'uploaded a new version of a file'
  },
  {
    key: 'building_passport.alias.add',
    value: 'added an alias for this building'
  },
  {
    key: 'building_passport.alias.remove',
    value: 'removed an alias for this building'
  },
  {
    key: 'building_passport.notes.add',
    value: 'added a new note'
  },
  {
    key: 'building_passport.notes.edit',
    value: 'edited a note'
  },
  {
    key: 'building_passport.notes.delete',
    value: 'deleted a note'
  },
  {
    key: 'building_passport.user.assign',
    value: 'assigned a new user'
  },
  {
    key: 'building_passport.user.update',
    value: 'updated user assignment'
  },
  {
    key: 'building_passport.user.revoke',
    value: 'revoked user access'
  },
  {
    key: 'building_passport.invitation.cancelled',
    value: 'cancelled an invitation'
  },
  {
    key: 'building_passport.user.detach',
    value: 'detached user access'
  },
  {
    key: 'building_passport.user.reactivate',
    value: 'reactivated user access'
  },
  {
    key: 'building_passport.units.add',
    value: 'added a new unit(s)'
  },
  {
    key: 'building_passport.units.delete',
    value: 'deleted a unit'
  },
  {
    key: 'building_passport.file_unshared_external',
    value: 'removed access to a file',
  },
  {
    key: 'building_passport.file_unshared_internal',
    value: 'removed access to a file',
  },
  {
    key: 'building_passport.file_shared_internal',
    value: 'shared a file'
  },
  {
    key: 'building_passport.file_shared_external',
    value: 'shared a file'
  },

  // Actions feature lifecycle
  { key: 'action.created',   value: 'raised a remedial' },
  { key: 'action.updated',   value: 'updated a remedial' },
  { key: 'action.converted', value: 'created a task from a remedial' },
  { key: 'action.dismissed', value: 'dismissed a remedial' },
  { key: 'action.reopened',  value: 'reopened a dismissed remedial' },
  { key: 'action.commented', value: 'commented on a remedial' },
  { key: 'action.resolved',  value: 'resolved a remedial' },
  { key: 'action.approved',  value: 'confirmed a remedial' },
  { key: 'action.owner_reassigned', value: 'changed the owner of a remedial' },
  { key: 'action.task_linked', value: 'linked a task to a remedial' },
  { key: 'action.task_unlinked', value: 'unlinked a task from a remedial' },
  { key: 'action.task_match_dismissed', value: 'dismissed a suggested task for a remedial' },
  { key: 'action.imported', value: 'imported a remedial from the previous system' },
  { key: 'action.import_undone', value: 'removed remedials imported from the previous system' },
  { key: 'building_passport.assets.imported', value: 'imported assets from the previous system' },
  { key: 'building_passport.imported_people_linked', value: 'linked a person to their records from the previous system' },
  { key: 'building_passport.imported_checks_linked', value: 'linked earlier checks from the previous system to their checklists for reference' },
  { key: 'building_passport.file_access_requested', value: 'asked to open documents' },
  { key: 'building_passport.file_access_approved', value: 'approved a request to open a document' },
  { key: 'building_passport.file_access_refused', value: 'refused a request to open a document' },
  { key: 'building_passport.file_access_withdrawn', value: 'withdrew a request to open a document' },
  { key: 'building_passport.file_access_redirected', value: 'passed a document access request to another contact' },
  { key: 'building_passport.file_access_legal_grant', value: 'granted access to a document under a legal requirement' },
  { key: 'building_passport.file_access_self_granted', value: 'gave themselves access to a document as an approver' },
  { key: 'building_passport.approver_access_given', value: 'gave a new approver access to the documents they now approve requests for' },
  { key: 'building_passport.approver_given_access', value: 'was given access to a document when made an approver' },
  { key: 'organisation.approver_route_changed', value: 'changed who approves document access requests' },
  { key: 'building_passport.onward_sharing_changed', value: 'changed whether a document or folder can be shared onward' },
  { key: 'building_passport.client_organisation_changed', value: 'changed which organisation this Building Passport belongs to' },
  { key: 'building_passport.succession', value: 'reactivated the Building Passport for a new owner' },

  // Incidents feature lifecycle
  { key: 'incident.logged',    value: 'logged an incident' },
  { key: 'incident.closed',    value: 'closed an incident' },
  { key: 'incident.commented', value: 'commented on an incident' },
  { key: 'incident.updated',   value: 'updated an incident' },
  { key: 'obligation.updated', value: 'updated an obligation' },
  { key: 'obligation.renamed', value: 'renamed an obligation' },
  { key: 'obligation.deleted', value: 'deleted an obligation' },
  { key: 'form_template.ai_drafted', value: 'drafted a form from a document with AI' },

  // Portfolio lifecycle
  { key: 'portfolio.created',          value: 'created a portfolio' },
  { key: 'portfolio.updated',          value: 'updated a portfolio' },
  { key: 'portfolio.deleted',          value: 'deleted a portfolio' },
  { key: 'portfolio.shared',           value: 'shared a portfolio' },
  { key: 'portfolio.unshared',         value: 'removed portfolio access' },
  { key: 'portfolio.building_added',   value: 'added a building to a portfolio' },
  { key: 'portfolio.building_removed', value: 'removed a building from a portfolio' },

  // Portfolio access control
  { key: 'portfolio.access.assign', value: 'gave someone access to the portfolio' },
  { key: 'portfolio.access.update', value: "changed a member's access level" },
  { key: 'portfolio.access.revoke', value: "removed someone's access to the portfolio" },

  // Portfolio documents
  { key: 'portfolio.files.add',              value: 'added a new file' },
  { key: 'portfolio.files.update',           value: 'updated a file' },
  { key: 'portfolio.files.delete',           value: 'deleted a file' },
  { key: 'portfolio.folder.created',         value: 'created a folder' },
  { key: 'portfolio.folder.updated',         value: 'updated a folder' },
  { key: 'portfolio.folder.deleted',         value: 'deleted a folder' },
  { key: 'portfolio.folder.file_assigned',   value: 'added a file to a folder' },
  { key: 'portfolio.folder.file_unassigned', value: 'removed a file from a folder' },
  { key: 'portfolio.folder.access_toggled',  value: 'changed who can access a folder' },
  { key: 'portfolio.file_shared_internal',   value: 'shared a file with someone' },
  { key: 'portfolio.file_unshared_internal', value: "removed someone's access to a file" },
  { key: 'portfolio.file_shared_external',   value: 'shared a file outside the platform' },
  { key: 'portfolio.file_unshared_external', value: 'removed external access to a file' },
  { key: 'portfolio.file_shared_to_bp',      value: 'shared a file with a building' },
  { key: 'portfolio.file_unshared_from_bp',  value: 'removed a file from a building' },
  { key: 'portfolio.file_shared_to_bp_bulk', value: 'shared files with multiple buildings' },

  // Estate lifecycle
  { key: 'estate.created',          value: 'created an estate' },
  { key: 'estate.updated',          value: 'updated an estate' },
  { key: 'estate.deleted',          value: 'deleted an estate' },
  { key: 'estate.shared',           value: 'shared an estate' },
  { key: 'estate.unshared',         value: 'removed estate access' },
  { key: 'estate.building_added',   value: 'added a building to an estate' },
  { key: 'estate.building_removed', value: 'removed a building from an estate' },

  // Estate access control
  { key: 'estate.access.update',           value: "changed a member's access level" },
  { key: 'estate.access_request.created',  value: 'requested access to the estate' },
  { key: 'estate.access_request.accepted', value: 'approved an access request' },
  { key: 'estate.access_request.deleted',  value: 'declined an access request' },
  { key: 'estate.invitation.deleted',      value: 'cancelled an invitation' },
  { key: 'estate.portfolio.attached',      value: 'added an estate to a portfolio' },
  { key: 'estate.portfolio.detached',      value: 'removed an estate from a portfolio' },

  // Estate documents
  { key: 'estate.files.add',              value: 'added a new file' },
  { key: 'estate.files.update',           value: 'updated a file' },
  { key: 'estate.files.delete',           value: 'deleted a file' },
  { key: 'estate.folder.created',         value: 'created a folder' },
  { key: 'estate.folder.updated',         value: 'updated a folder' },
  { key: 'estate.folder.deleted',         value: 'deleted a folder' },
  { key: 'estate.folder.file_assigned',   value: 'added a file to a folder' },
  { key: 'estate.folder.file_unassigned', value: 'removed a file from a folder' },
  { key: 'estate.folder.access_toggled',  value: 'changed who can access a folder' },
  { key: 'estate.file_shared_external',   value: 'shared a file outside the platform' },
  { key: 'estate.file_unshared_external', value: 'removed external access to a file' },
  { key: 'estate.file_shared_to_bp',      value: 'shared a file with a building' },
  { key: 'estate.file_unshared_from_bp',  value: 'removed a file from a building' },
  { key: 'estate.file_shared_to_bp_bulk', value: 'shared files with multiple buildings' },

  // Report / document exports
  { key: 'report.exported', value: 'exported a report' },
  { key: 'user.email_frequency.changed', value: 'changed how often they get email updates' },
  { key: 'building_passport.sharepoint.folder_changed', value: 'changed the synced SharePoint folder' },
  { key: 'building_passport.sharepoint.connected', value: 'connected a SharePoint folder' },
  { key: 'building_passport.sharepoint.access_changed', value: 'changed who can see a synced SharePoint folder' },

  { key: 'file.identity.detected', value: 'marked a file as a restricted identity document' },
  { key: 'file.identity.cleared', value: 'confirmed a file is not an identity document' },
  { key: 'file.identity.overridden', value: 'changed whether a file is an identity document' },
  { key: 'file.share.refused_identity', value: 'tried to share a restricted identity document' },

  { key: 'file.quarantined', value: 'removed a photo for review' },
  { key: 'file.quarantine_released', value: 'restored a photo after review' },
  { key: 'file.quarantine_deleted', value: 'permanently deleted a reviewed photo' },
  { key: 'building_passport.identity_documents_retention_deleted', value: 'deleted identity documents after the retention period' },
  { key: 'building_passport.identity_retention_changed', value: 'changed identity document retention' }

  // {
  //   key: 'file_external_preview',
  //   value: 'previewed a file (external)'
  // },
  // {
  //   key: 'file_external_download',
  //   value: 'downloaded a file (external)'
  // },
  // {
  //   key: 'file_external_access',
  //   value: 'accessed the file page (external)'
  // }
]


export const ROLE_DESCRIPTION = {
  agent: 'Works on this building: can upload and update documents and tasks, but cannot see documents that have not been shared with them.',
  landlord: '"Landlord" refers to the freeholder or long leaseholder of the property. If this is under corporate ownership, a contact person must be identified.',
  owner: 'Full control of this building: can see every document, change details, and add or remove people.',
  responsiblePerson: '"Responsible Person" - select this if you are a "Building Safety Manager" or "Accountable Person" - i.e. if is your explicit responsibility for an element of building safety. There may be more than one for any building.',
  responsible_person: '"Responsible Person" - select this if you are a "Building Safety Manager" or "Accountable Person" - i.e. if is your explicit responsibility for an element of building safety. There may be more than one for any building.',
  emergencyService: 'FRS refers to any person working for the Fire and Rescue Service.',
  occupant: 'An Occupant is a person who resides in or regularly uses a property.',
  user: 'Common user role refers to the freeholder, long leaseholder of the property or any person working on behalf of, or representing, the owner/landlord or another agent of the building. Also includes person who is officially responsible for reducing the risk from fire and making sure that people can safely escape if the case of a fire (as set out in The Regulatory Reform (Fire Safety) Order 2005).',
  prospectivePurchaser: 'A prospective purchaser will have access to a read-only version of the Building Passport. If you invite a prospective purchaser, only you will see their details (i.e. email address and name). Other users with access to this Building Passport will see this user as “Anonymous user - invited by [User name]"',
  prospective_purchaser: 'A prospective purchaser will have access to a read-only version of the Building Passport. If you invite a prospective purchaser, only you will see their details (i.e. email address and name). Other users with access to this Building Passport will see this user as “Anonymous user - invited by [User name]"',
  principalAccountablePerson: '',
  principal_accountable_person: '',
  principalDesigner: '',
  principal_designer: ''
}


export const TEMPLATE_ITEMS = [
  {
    label: 'UPRN',
    value: 'hasUprn'
  },
  {
    label: 'Address',
    value: 'hasAddress'
  },
  {
    label: 'Building type',
    value: 'hasBuildingTypes'
  },
  {
    label: 'User details',
    value: 'hasAgent'
  },
  {
    label: 'Admin details',
    value: 'hasOwner'
  }
]

export const TEMPLATE_ITEMS_NAMES = {
  hasUprn: 'UPRN',
  hasAddress: 'Address',
  hasBuildingTypes: 'Building type',
  hasAgent: 'User details',
  hasOwner: 'Admin details'
}
